module.exports = __webpack_public_path__ + "media/images/area/feature/kansai/related/id/1-47f8e367580db89a7a6b3373f00fbc1c.jpg";